import { useMsal } from '@azure/msal-react';
import { useTranslation } from 'react-i18next';
import { loginRequest } from '../config/config';

const LoginPage = () => {
  const { instance } = useMsal();
  const { t } = useTranslation();

  const handleLogin = () => {
    const inIframe = window !== window.parent;
    if (inIframe) {
      instance.loginPopup(loginRequest).catch(e => {
        console.error('Popup login error:', e);
      });
    } else {
      instance.loginRedirect(loginRequest).catch(e => {
        console.error('Redirect login error:', e);
      });
    }
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <img src="/logo.png" alt="Logo Powell" className="login-logo" />

        <p className="login-container-content">
          <b>{t('description')}</b><br /><br />
          <span className="login-subdescription">{t('subDescription')}</span>
        </p>

        <button className="login-button" onClick={handleLogin}>
          {t('signIn')}
        </button>

        <p className="login-footer">
          {t('footer')}
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
